<script setup>
import { onMounted } from 'vue'
import { useLanguageStore } from '@/stores/language'
import { useIdleLogout } from '@/composables/useIdleLogout'

const languageStore = useLanguageStore()

// Auto-logout after 30 minutes of inactivity
useIdleLogout()

onMounted(() => {
  // Ensure language is initialized when app mounts
  languageStore.initializeLanguage()
})
</script>

<template>
    <router-view />
</template>

<style>
/* RTL-specific styles */
html[dir="rtl"] {
  direction: rtl;
}

html[dir="ltr"] {
  direction: ltr;
}

/* Fix for PrimeVue components in RTL */
html[dir="rtl"] .p-dropdown-panel {
  left: auto;
  right: 0;
}

/* html[dir="rtl"] .p-menu {
  left: auto;
  right: 0;
} */

html[dir="rtl"] .p-tooltip {
  left: auto;
  right: 0;
}

/* RTL adjustments for custom components */
html[dir="rtl"] .pi-chevron-left::before {
  content: "\e908"; /* chevron-right */
}

html[dir="rtl"] .pi-chevron-right::before {
  content: "\e907"; /* chevron-left */
}

html[dir="rtl"] .pi-angle-left::before {
  content: "\e931"; /* angle-right */
}

html[dir="rtl"] .pi-angle-right::before {
  content: "\e930"; /* angle-left */
}

/* Ensure images and icons don't flip unless needed */
html[dir="rtl"] img,
html[dir="rtl"] .no-flip {
  transform: scaleX(1);
}

/* Fix for flex layouts in RTL */
html[dir="rtl"] .flex-row {
  flex-direction: row-reverse;
}

html[dir="rtl"] .flex-row-reverse {
  flex-direction: row;
}
</style>
